import { Field } from 'formik';
import { Grid } from '@mui/material';
import MuiValidSelect from 'src/components/input/MuiValidSelect';
import MuiValidTextField from './input/MuiValidTextField';

const SoldInformation = () => {
  return (
    <>
      <Grid
        id="sold-information"
        container
        sx={{ mt: '0.1rem' }}
        rowSpacing={4}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Who has the Equipment?"
            name="soldEquipTo"
            placeholder="Name, Address, Phone"
            variant="standard"
            inputProps={{ maxLength: 2000 }}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '100%' }}
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date Business Sold"
            name="dateBusSold"
            type="Date"
            InputLabelProps={{ shrink: true }}
            variant="standard"
            sx={{ width: '100%' }}
          ></Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidSelect}
            itemValues={['T', 'F']}
            itemLabels={['Yes', 'No']}
            label="Business is at same location?"
            name="busSameLoc"
            variant="standard"
          ></Field>
        </Grid>

        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date of New Business License"
            name="newBusLicDate"
            type="Date"
            InputLabelProps={{ shrink: true }}
            variant="standard"
            sx={{ width: '100%' }}
          ></Field>
        </Grid>
      </Grid>
    </>
  );
};

export default SoldInformation;
